module.exports = __webpack_public_path__ + "static/media/winLarge61_1.0b1a97e3.svg";